<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">姓名</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_name" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">性别</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.em_sex"
              placeholder="请选择"
            >
              <option>男</option>
              <option>女</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">婚姻状态</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.em_marital"
              placeholder="请选择"
            >
              <option>已婚</option>
              <option>未婚</option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
          <div class="weui-cell__hd">
            <label for class="weui-label">学历</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.em_xl"
              placeholder="请选择"
            >
              <option>小学</option>
              <option>初中</option>
              <option>中专</option>
              <option>高中</option>
              <option>大专</option>
              <option>本科</option>
              <option>硕士研究生</option>
              <option>博士研究生</option>
            </select>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">专业</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_zy" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">毕业院校</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_byschool" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">邮箱</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.em_email"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">地址</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_address" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">身份证号</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_id_card" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">紧急联系人</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_emergencyname" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">联系人关系</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.em_emergencygx" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">联系人电话</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.em_emergencytel" placeholder="请填写" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    this.reqData()
  },
  methods: {
    reqData() {
      var me = this
      me.$loading({
        url: "/api/document/employee/read/current"
      }).then(function (res) {
        if (res.success) {
          me.form = res.data.main
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    save() {
      var me = this,
        main = me.form;
      if (!main.em_name) {
        me.$weui.topTips("请填写姓名", 2000);
      } else {
        me.$loading({
          url: "/api/document/employee/save/current",
          method: 'POST',
          jsonData: main
        }).then(function (res) {
          if (res.success) {
            me.$weui.toast("保存成功", 1000);
            setTimeout(() => {
              me.$router.back()
            }, 1000)
          } else {
            me.$router.push({
              name: "Error",
              params: res
            });
          }
        });
      }
    }
  },
};
</script>